import styled from "styled-components";

export const HomeDiv = styled.div`
  background-image: url("https://j.gifs.com/vQJxxY.gif");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
`;